export default __webpack_public_path__ + "static/media/spinach.22a9f4bc.png";